import { genericConstants } from "../constants/GenericConstants";

export const setDefaultLanguageAction = (data) => {
    return {
        type: genericConstants.SET_DEFAULT_LANGUAGE,
        payload: data,
    };
};